import { createSearchGrid } from './BaseSearchGrid.js';
import { techTransferConfig } from '@js/config/algolia.js';
import { configure } from 'instantsearch.js/es/widgets';
import { buildCompleteFilterString } from '@js/algolia/filterUtils.js';

// Load user watch progress once at module init (keyed by Craft entry ID)
const _progressEl = document.getElementById('user-video-progress');
const userVideoProgress = _progressEl ? JSON.parse(_progressEl.textContent || '{}') : {};

function formatCardData(result) {
  // objectID format is "entryId-siteId" — extract entry ID for progress lookup
  const entryId = result.objectID ? result.objectID.split('-')[0] : null;
  const progress = entryId ? (userVideoProgress[entryId] ?? null) : null;
  return {
    title: result.title,
    url: result.absoluteUri || result.url,
    image: result.featuredImage,
    shortDescription: result.shortDescription,
    postDate: result.postDate
      ? new Date(result.postDate * 1000).toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
        })
      : '',
    postDateTimestamp: result.postDate || 0,
    videoLength: result.videoLength,
    wistiaId: result.wistiaId || '',
    watchStatus: progress?.status ?? null,
    watchPercent: progress?.percent ?? 0,
    authorFullName: result.authorFullName,
    authorJobTitle: result.authorJobTitle,
    authorPhoto: result.authorPhoto,
    authorSlug: result.authorSlug,
    skillLevel: result.skillLevel,
    techTransferMainTopic: result.techTransferMainTopic,
    applications: result.applications,
  };
}

export default createSearchGrid({
  appId: techTransferConfig.app_id,
  apiKey: techTransferConfig.api_key,
  indexName: techTransferConfig.index,
  configureWidget: configure({
    filters: buildCompleteFilterString(window.algoliaConfig?.site_id),
    hitsPerPage: 24,
  }),
  formatCardData,
  scrollToSelector: '[data-search-videos]',
});
